// extracted by mini-css-extract-plugin
export default {"about":"AboutInfo_about__DglqE","big_image":"AboutInfo_big_image__FK1Ue"};